module.exports = __webpack_public_path__ + "img/v4_trade1.b530f846.png";